import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { thunderstormCapabilitiesGroup } from '@nu-art/thunderstorm-frontend/consts';
import { ModuleFE_FloatingWindows } from '../../_modules/ModuleFE_FloatingWindows.js';
import { windowRect } from '../../_utils/get-window-rect.js';
class ATS_FloatingWindows_Class extends ComponentSync {
    openHalfLeft = () => {
        const model = {
            key: 'ats-window-1',
            content: (cb) => this.renderWindowContent('Test Half Left', cb),
            resizable: true,
            moveable: true,
            rect: windowRect.halfScreen_Left()
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    openHalfRight = () => {
        const model = {
            key: 'ats-window-2',
            content: (cb) => this.renderWindowContent('Test Half Right', cb),
            resizable: true,
            moveable: true,
            rect: windowRect.halfScreen_Right(),
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    openThirdLeft = () => {
        const model = {
            key: 'ats-window-3',
            content: (cb) => this.renderWindowContent('Test Third Left', cb),
            resizable: true,
            moveable: true,
            rect: windowRect.thirdScreen_Left(),
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    openThirdMiddle = () => {
        const model = {
            key: 'ats-window-4',
            content: (cb) => this.renderWindowContent('Test Third Middle', cb),
            resizable: true,
            moveable: true,
            rect: windowRect.thirdScreen_Middle(),
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    openThirdRight = () => {
        const model = {
            key: 'ats-window-5',
            content: (cb) => this.renderWindowContent('Test Third Right', cb),
            resizable: true,
            moveable: true,
            rect: windowRect.thirdScreen_Right(),
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    render() {
        return _jsxs(LL_V_L, { style: { gap: 10 }, children: [_jsx(Button, { variant: 'primary', onClick: this.openHalfLeft, children: "Open Half Left" }), _jsx(Button, { variant: 'primary', onClick: this.openHalfRight, children: "Open Half Right" }), _jsx(Button, { variant: 'primary', onClick: this.openThirdLeft, children: "Open Third Left" }), _jsx(Button, { variant: 'primary', onClick: this.openThirdMiddle, children: "Open Third Middle" }), _jsx(Button, { variant: 'primary', onClick: this.openThirdRight, children: "Open Third Right" })] });
    }
    renderWindowContent = (content, cb) => {
        return _jsxs(LL_H_C, { style: { gap: 10 }, children: [content, _jsx(Button, { variant: 'secondary', onClick: cb, children: "Close" })] });
    };
}
export const ATS_FloatingWindows = {
    key: 'ats__floating-windows',
    name: 'Floating Windows',
    renderer: ATS_FloatingWindows_Class,
    group: thunderstormCapabilitiesGroup
};
//# sourceMappingURL=ATS_FloatingWindows.js.map